/**
 * @file コンポーネント：フル動画ページ手術情報 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Slider } from "~/src/components/uiparts/Slider";

// 関数読み込み
import { fnConvertLineStringToHtml } from "~/src/functions/common";

// スタイル設定読み込み
import {
    StyledButton,
    StyledButtonIcon,
    StyledButtonText,
    StyledButtonlist,
    StyledButtonlistItem,
    StyledContainer,
    StyledContents,
    StyledEdit,
    StyledEditLink,
    StyledEditLinkIcon,
    StyledEditLinkText,
    StyledEditText,
    StyledSliderImage,
    StyledSliderlist,
    StyledSliderlistItem,
    StyledText,
    StyledTextParagraph,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledContainer>
            <StyledContents>
                {/* 画像スライダー */}
                {props.sliders.length > 0 && props.arrayCurrentIndex && window.dataUser.isLogin === true && (
                    <StyledSliderlist>
                        {props.sliders.map((slider, index) => (
                            <StyledSliderlistItem key={"slider-" + index}>
                                <Slider
                                    arrows={true}
                                    defaultIndex={
                                        props.arrayCurrentIndex[index]
                                    }
                                    dots={true}
                                    list={slider.map((slide, i) => (
                                        <StyledSliderImage
                                            alt=""
                                            key={"slide-" + i}
                                            src={slide.contentUrl}
                                            isLogin={window.dataUser.isLogin}
                                        />
                                    ))}
                                    zoom={true}
                                />
                            </StyledSliderlistItem>
                        ))}
                    </StyledSliderlist>
                )}
                {/* テキスト */}
                <StyledText>
                    <StyledTextParagraph
                        dangerouslySetInnerHTML={{
                            __html: fnConvertLineStringToHtml(props.text),
                        }}
                        ref={props.refText}
                    />
                    {props.isEditPage === true && (
                        // 執刀医権限の場合のみ
                        <StyledEdit>
                            {props.languageCodeOperation === "en" && (
                                <StyledEditText>
                                    {localized["Label.UneditableEnglishData"]}
                                </StyledEditText>
                            )}
                            <StyledEditLink
                                className={
                                    props.languageCodeOperation === "en" &&
                                    "is-disabled"
                                }
                                href="#"
                                onClick={(e) =>
                                    props.fnSetModalEdit(
                                        e,
                                        props.type,
                                        "edit",
                                        {
                                            context:
                                                props.refText.current.innerText,
                                            targets: [props.refText.current],
                                        }
                                    )
                                }
                            >
                                <StyledEditLinkIcon>
                                    <i className="fas fa-edit"></i>
                                </StyledEditLinkIcon>
                                <StyledEditLinkText>
                                    {localized["Label.Edit"]}
                                </StyledEditLinkText>
                            </StyledEditLink>
                        </StyledEdit>
                    )}
                </StyledText>
            </StyledContents>
            {/* 動画タブ切り替えボタン */}
            <StyledButtonlist>
                {props.hasDigest && (
                    // ダイジェスト動画がある場合のみ
                    <StyledButtonlistItem>
                        <StyledButton
                            onClick={() => {
                                props.setSelectedContentsData("digestvideo");
                            }}
                        >
                            <StyledButtonIcon>
                                <i className="fas fa-play"></i>
                            </StyledButtonIcon>
                            <StyledButtonText>
                                {localized["Label.PlayDigestVideo"]}
                            </StyledButtonText>
                        </StyledButton>
                    </StyledButtonlistItem>
                )}
                <StyledButtonlistItem>
                    <StyledButton
                        className={
                            props.isEditPage !== true &&
                            props.isPaid === true &&
                            props.isPurchased === false &&
                            "is-disabled"
                        }
                        onClick={() => {
                            if (
                                props.isEditPage !== true &&
                                props.isPaid === true &&
                                props.isPurchased === false
                            ) {
                                // 執刀医権限、管理者権限でない有料コンテンツかつ未購入の場合、決済情報ポップアップを強調表示
                                props.setIsHighlightPopupPayment(true);
                            } else if (!window.dataUser.isLogin) {
                                // 非ログイン時にログインモーダルを出す
                                props.setIsOpenModalLogin(true);
                            } else {
                                // 上記以外の場合、メインコンテンツをフル動画に切り替え
                                props.setSelectedContentsData("fullvideo");
                            }
                        }}
                        title={
                            props.isEditPage !== true &&
                            props.isPaid === true &&
                            props.isPurchased === false
                                ? localized["Label.PurchaseToPlayFullvideo"]
                                : null
                        }
                    >
                        <StyledButtonIcon>
                            <i className="fas fa-play"></i>
                        </StyledButtonIcon>
                        <StyledButtonText>
                            {localized["Label.PlayFullVideo"]}
                        </StyledButtonText>
                    </StyledButton>
                </StyledButtonlistItem>
            </StyledButtonlist>
        </StyledContainer>
    );
};
